/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UnitPrice } from "./UnitPrice";
export type TrialRowUpdate = {
  id: string;
  index?: number;
  selected_public_raw_material_id?: string;
  selected_organization_raw_material_id?: string;
  substance_ids?: Array<string>;
  phase?: string;
  functions?: Array<string>;
  amount_pct?: number;
  inline_unit_price?: UnitPrice;
  unset?: TrialRowUpdate.unset;
};
export namespace TrialRowUpdate {
  export enum unset {
    INDEX = "index",
    SELECTED_PUBLIC_RAW_MATERIAL_ID = "selected_public_raw_material_id",
    SELECTED_ORGANIZATION_RAW_MATERIAL_ID = "selected_organization_raw_material_id",
    SUBSTANCE_IDS = "substance_ids",
    PHASE = "phase",
    FUNCTIONS = "functions",
    AMOUNT_PCT = "amount_pct",
    INLINE_UNIT_PRICE = "inline_unit_price",
  }
}
